export const supportedLanguages = ['de', 'en', 'ar', 'fr'] as const;

export type AllTenantsSupportedLanguages = 'de' | 'en' | 'ar' | 'fr';

export type Language = (typeof supportedLanguages)[number];

export const RTL_LANGUAGES: Language[] = ['ar'];

export const defaultLanguage: Language =
  (process.env.NEXT_PUBLIC_LANGUAGE as Language) || 'en';
